import { chain } from 'lodash';
import { PAGE_VIEW_EVENT_NAME } from '../config/pixelTesterConsts';

export const prettifyJson = jsonString => {
    try {
        return JSON.stringify(JSON.parse(jsonString), null, 2);
    } catch {
        return jsonString;
    }
};

export const extractConditions = event => {
    if (!event?.matchedRules) return [];

    return chain(event.matchedRules)
        .transform((acc, rule) => {
            if (rule?.condition?.property === 'URL') {
                const { value, predicate } = rule.condition;
                acc[value] = { name: predicate, value };
            }
        }, {})
        .values()
        .value();
};

export const countEventIssues = events =>
    events?.reduce((issueCount, event) => {
        const hasValidationErrors = event.eventParameters?.some(param => param.validationError != null);
        const isUnrecognisedEvent = !event.matchedRules?.length && event.eventName !== PAGE_VIEW_EVENT_NAME;

        return hasValidationErrors || isUnrecognisedEvent ? issueCount + 1 : issueCount;
    }, 0);
